// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 465) return "static/chunks/sanity-0b246a7a-2c73494149827d6c.js";
	if (chunkId === 2071) return "static/chunks/sanity-9323fff6-a0965ffb32135259.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2672":"4f6afdbc32eec03b","5711":"2442f0e3c6a22605"}[chunkId] + ".js";
};